module.exports = __webpack_public_path__ + "img/backicon.cf58d6f3.png";